import { render } from "./banner.vue?vue&type=template&id=765fe338&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=765fe338&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765fe338"]])

export default __exports__